export default defineNuxtPlugin(() => {
    const config = useRuntimeConfig();
    const BASE_PROGETTO = config.public.base_progetto;

    return {
        provide: {
            localStorage: {
                getItem(item) {
                    if (true) {
                        return localStorage.getItem(item + BASE_PROGETTO);
                    } else {
                        return undefined;
                    }
                },

                setItem(item, value) {
                    if (true) {
                        return localStorage.setItem(item + BASE_PROGETTO, value);
                    }
                },

                removeItem(item) {
                    if (true) {
                        return localStorage.removeItem(item + BASE_PROGETTO);
                    }
                },
            },
        },
    };
});
